﻿<div bsModal #modalContent="bs-modal" class="modal fade notification" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                {{title}}
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="pull-right" src="{{iconImg}}" [ngClass]="iconClass">
                    </div>
                    <div class="col-sm-10">
                        {{content}}
                        <ng-template #templateBody>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="cancelEnabled" class="btn btn-default" (click)="hide(cancelType)">{{'Notifications.Button_Cancel' | translate }}</button>
                <button type="button" *ngIf="okEnabled" class="btn btn-primary" (click)="hide(okType)">{{'Notifications.Button_Ok' | translate }}</button>
                <button type="button" *ngIf="noEnabled" class="btn btn-default" (click)="hide(noType)">{{'Notifications.Button_No' | translate }}</button>
                <button type="button" *ngIf="yesEnabled" class="btn btn-primary" (click)="hide(yesType)">{{'Notifications.Button_Yes' | translate }}</button>
            </div>
        </div>
    </div>
</div>